let TILES = [
  {
    name: 'districts',
    label: 'DISTRICTS',
    icon: '',
    count: 0
  },
  {
    name: 'schools',
    label: 'SCHOOLS',
    icon: '',
    count: 0
  },
  {
    name: 'courses',
    label: 'COURSES',
    icon: '',
    count: 0
  },
  {
    name: 'sections',
    label: 'SECTIONS',
    icon: '',
    count: 0
  },
  {
    name: 'teachers',
    label: 'TEACHERS',
    icon: '',
    count: 0
  },
  {
    name: 'students',
    label: 'STUDENTS',
    icon: '',
    count: 0
  },
  {
    name: 'errors',
    label: 'ERRORS',
    href: '/errors',
    icon: '',
    count: 0
  }
];

export default TILES;



// WEBPACK FOOTER //
// ./app/models/tiles.js